<template>
  <BaseModalSmall
    @close="close"
    v-show="show"
    :show="show"
    v-bind:isValidated="validateForm"
    v-bind:loading="showProgress"
    @confirm="save"
  >
    <template v-slot:header>{{ title }}</template>
    <template v-slot:body>
      <div class="row">
        <BeneficiaryAccordian
          v-bind:name="data.full_name"
          v-on:name="data.full_name = $event"
          v-bind:gender="data.gender"
          v-on:gender="data.gender = $event"
          v-bind:email="data.email"
          v-on:email="data.email = $event"
          v-bind:address="data.address"
          v-on:address="data.address = $event"
          v-bind:phone="data.phone"
          v-on:phone="data.phone = $event"
          v-bind:relationship="data.relationship"
          v-on:relationship="data.relationship = $event"
          v-bind:person="data.id"
          v-on:person="data.id = $event"
          v-bind:manualRelationship="manualRelationship"
          v-on:manualRelationship="manualRelationship = $event"
          :close="show"
          :errors="errors"
          :groupNotRequired="true"
          :peopleOptionList="peopleOptionList"
          @showExisting="clearNew(), clearGroup()"
          @showNew="clearExsisting(), clearGroup()"
          @showGroup="clearExsisting(), clearNew()"
          @clearBeneficiaryError="errors.beneficiary = null"
          @clearFullNameError="errors.full_name = null"
          @clearEmailError="errors.email = null"
          @clearAddressError="errors.address = null"
          @clearPhoneError="errors.phone = null"
        >
        </BeneficiaryAccordian>
      </div>
    </template>
    <template v-slot:button>
      {{ buttonText }}
    </template>
  </BaseModalSmall>
</template>

<script>
import BaseModalSmall from '@/common/ui/BaseModalSmall'
import BeneficiaryAccordian from '@/views/pages/GiftsPage/Questions/Modals/BeneficiaryAccordian'
import { http } from '@/services'

export default {
  name: 'DistributionPersonModal',
  components: {
    BaseModalSmall,
    BeneficiaryAccordian
  },
  props: ['show', 'peopleOptionList', 'primary', 'backup'],
  watch: {
    primary: {
      immediate: true,
      handler(value) {
        if (value) this.data.distribution_primary = true
      }
    },
    backup: {
      immediate: true,
      handler(value) {
        if (value) this.data.distribution_backup = true
      }
    }
  },
  computed: {
    validateForm() {
      if (this.data.id) return true
      if (this.data.full_name && this.data.gender && this.data.relationship) {
        if (
          this.data.relationship === 'friend' &&
          (this.data.phone || this.data.address || this.data.email)
        )
          return true
        else if (this.data.relationship === 'other' && this.manualRelationship)
          return true
        else if (
          this.data.relationship !== 'friend' &&
          this.data.relationship !== 'other'
        )
          return true
      }
      return false
    },
    title() {
      return 'Add Recipient (Person)'
    },
    buttonText() {
      return 'Add Person'
    },
    people() {
      return this.$store.getters.people
    }
  },
  data() {
    return {
      data: {
        id: '',
        full_name: null,
        address: null,
        email: null,
        phone: null,
        gender: null,
        relationship: '',
        distribution_primary: false,
        distribution_backup: false
      },
      errors: {
        beneficiary: '',
        full_name: '',
        address: '',
        email: '',
        phone: ''
      },
      showProgress: false,
      manualRelationship: ''
    }
  },
  methods: {
    close() {
      this.$emit('close')
      this.clearAll()
    },
    save(value) {
      if (this.data.id) {
        this.patch()
      } else {
        this.post()
      }
    },
    clearErrors() {
      this.errors.amount = ''
      this.errors.full_name = ''
      this.errors.address = ''
      this.errors.phone = ''
      this.errors.email = ''
      this.errors.beneficiary = ''
    },
    clearAll() {
      this.data.id = null
      this.clearExsisting()
      this.clearNew()
      this.clearGroup()
    },
    clearExsisting() {
      this.data.id = ''
    },
    clearNew() {
      this.data.full_name = null
      this.data.address = null
      this.data.email = null
      this.data.phone = null
      this.data.gender = null
      this.data.relationship = ''
    },
    clearGroup() {
      this.data.beneficiary_group_share = null
      this.data.beneficiary_group = ''
    },
    post() {
      this.clearErrors()
      if (this.data.relationship === 'other' && this.manualRelationship)
        this.data.relationship = this.manualRelationship
      http
        .post('/wills/api/person', this.data)
        .then((response) => {
          this.$store.commit('personAdd', response.data)
          this.close()
          this.$notification.success('Person Added')
        })
        .catch((error) => {
          this.errorHandler(error)
        })
    },
    patch() {
      this.clearErrors()
      var person = this.people.find((person) => person.id === this.data.id)
      var personCopy = Object.assign({}, person)
      if (this.primary) personCopy.distribution_primary = true
      else if (this.backup) personCopy.distribution_backup = true
      this.$store.commit('personAdd', personCopy)
      this.$notification.success('Person added')
      this.close()
    },
    errorHandler(e) {
      if (e.response.data.amount) {
        this.errors.amount = e.response.data.amount[0]
      }
      if (e.response.data.beneficiary) {
        this.errors.beneficiary = e.response.data.beneficiary[0]
      }
      if (e.response.data.full_name) {
        this.errors.full_name = e.response.data.full_name[0]
      }
      if (e.response.data.phone) {
        this.errors.phone = e.reponse.data.phone[0]
      }
      if (e.response.data.email) {
        this.errors.email = e.reponse.data.email[0]
      }
      if (e.response.data.address) {
        this.errors.address = e.reponse.data.address[0]
      }
    }
  }
}
</script>
